import cn from "classnames";
import type { ComponentPropsWithRef } from "react";
import styles from "./Spinner.module.css";

export function Spinner(props: ComponentPropsWithRef<"div">) {
  const { className, ...rest } = props;

  return <div className={cn(styles.spinner, className)} {...rest} />;
}
